<template>
  <div class="content">
    <PageHeader title="Widget" />
    <section class="page-content container-fluid">
      <div class="card">
        <h3 class="card-header">
          <label class="form-label">Titulo</label>
          <input placeholder="Titulo..." type="text" class="form-control" v-model="configs.title">
        </h3>
        <div class="card-body">
          <div class="py-2">
            <label class="form-label">Mensagem de introdução</label>
            <textarea class="form-control" v-model="configs.intro"></textarea>
          </div>
          <div class="py-2">
            <h2>Alinhamento</h2>
            <div class="widget-config-aligns">
              <p v-if="configs.align === 'left'">Esquerda</p>
              <p v-else-if="configs.align === 'center'">Centro</p>
              <p v-else-if="configs.align === 'right'">Direita</p>
              <div class="row py-3 px-5">
                <div class="col-4">
                  <button @click="configs.align = 'left'" :class="{ active: configs.align === 'left'}">
                    <span class="sr-only">Alinhar widget para esquerda</span>
                  </button>
                </div>
                <div class="col-4">
                  <button @click="configs.align = 'center'" :class="{ active: configs.align === 'center'}">
                    <span class="sr-only">Alinhar widget para center</span>
                  </button>
                </div>
                <div class="col-4">
                  <button @click="configs.align = 'right'" :class="{ active: configs.align === 'right'}">
                    <span class="sr-only">Alinhar widget para direita</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-12">
              <div class="widget-config-colors">
                <h2>Cor geral</h2>
                <color-picker :value="configs.mainColor" :disableAlpha="true" @input="updateMainColor" />
              </div>
            </div>
            <div class="col-lg-6 col-12">
              <div class="widget-config-colors">
                <h2>Cor do push</h2>
                <color-picker :value="configs.pushColor" :disableAlpha="true" @input="updatePushColor" />
              </div>
            </div>
          </div>
          <hr>

          <div class="p-y-3">
            Copie o código abaixo e cole no head do seu site
          </div>
<pre class="form-control script-content" readonly ref="code" v-if="domain">&lt;script src="{{domain}}/yupchat.js"&gt;&lt;/script&gt;
&lt;script&gt;
var widget = YupChat();
widget.config({
  align: '{{configs.align}}',
  color: '{{configs.mainColor}}',
  pushColor: '{{configs.pushColor}}',
  title: '{{configs.title}}'{{configs.intro ? ',' : ''}}{{configs.intro ? `
  intro: '${configs.intro.replace(/'/g, '\'\'').replace(/\n/g, '\\n')}'` : ''}}
});
widget.open('{{account.id}}');
&lt;/script&gt;</pre>
        </div>
        <footer class="card-footer bg-light py-2">
          <button class="btn btn-success float-right" @click="copyData">
            <i class="fas fa-clipboard color-white"></i>
            <span class="hide-mobile">Copiar</span>
          </button>
        </footer>
      </div>
    </section>

    <div class="widget" :class="{
      open: visible,
      center: configs.align === 'center',
      left: configs.align === 'left',
      right: configs.align === 'right',
    }">
      <header :class="{ lighter: isLighter(configs.mainColor, 127.5) }" :style="{ backgroundColor: configs.mainColor }">
        <button @click="toggleVisibility">
          <i class="widget-min" :class="{ lighter: isLighter(configs.mainColor, 127.5) }"></i>
        </button>
        <button class="widget-r" @click="toggleVisibility">
          <i class="widget-close" :class="{ lighter: isLighter(configs.mainColor, 127.5) }"></i>
        </button>
        <h1>{{configs.title}}</h1>
      </header>
      <section>
        <div class="widget-msg">
          <div>
            <span>{{configs.intro}}</span>
            <div class="widget-status">
              <time datetime="2022-03-12T22:22:11.898">Agora</time>
              <span class="widget-msg-status">🗸🗸</span>
            </div>
          </div>
          <footer>
            <span>Agente</span>
          </footer>
        </div>
        <div
          class="widget-msg me"
          :class="{ lighter: isLighter(configs.mainColor, 127.5) }"
          :style="{ color: configs.mainColor }"
        >
          <div>
            <span>João Almeida</span>
            <div class="widget-status">
              <time datetime="2022-03-12T22:22:11.898">Agora</time>
              <span class="widget-msg-status">🗸🗸</span>
            </div>
          </div>
          <footer>
            <span>Cliente</span>
          </footer>
        </div>
      </section>
      <footer>
        <input type="text" v-model="message">
        <div class="widget-placeholder" v-if="!message">
          <span>Digite sua mensagem...</span>
        </div>
        <div class="widget-extras">
          <Emojis
            setClass="no"
            icon="widget-emoji"
            left="-4px"
            bottom="40px" />
          <button class="widget-btn" disabled>
            <i class="widget-attach"></i>
          </button>
        </div>
        <button class="widget-btn">
          <i class="widget-send" :style="{ color: configs.mainColor }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" :style="{ fill: configs.mainColor }">
              <path d="M958 461.2L73.8 18.4C31.2-3 3.2 18 11.5 65l55.2 309.6c6 33.9 31.6 64.8 63.2 80.9h328c24.6 0 44.5 20 44.5 44.6s-19.9 44.6-44.5 44.6h-333c-29.2 17-52.4 46.4-58.1 78.5L11.5 935c-8.3 47 19.7 67.9 62.3 46.6L958 538.8c42.7-21.3 42.7-56.2 0-77.6z"/>
            </svg>
          </i>
        </button>
      </footer>
    </div>
    <button
      class="widget-launch"
      @click="toggleVisibility"
      :style="{ backgroundColor: configs.mainColor }"
      :class="{
        center: configs.align === 'center',
        left: configs.align === 'left',
        right: configs.align === 'right',
      }">
      <span class="widget-push" :style="{ backgroundColor: configs.pushColor, color: isLighter(configs.pushColor, 201) ? '#000' : '#fff' }">1</span>
      <i class="widget-logo"></i>
    </button>
  </div>
</template>

<script>
import Emojis from '@/components/Emojis.vue';
import PageHeader from '@/components/PageHeader.vue';

export default {
  name: 'Widget',
  components: {
    // InfiniteLoading,
    Emojis,
    PageHeader,
  },
  data() {
    return {
      visible: true,
      message: '',
      colors: {
        hex: '#0E1421',
      },
      configs: {
        align: 'right',
        mainColor: '#0E1421',
        pushColor: '#00cc00',
        title: this.account?.name ?? 'Yup Chat',
        intro: 'Olá tudo bem? Para poder ajudar, qual seu nome completo?',
      },
    };
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
    domain() {
      const domain = process.env?.VUE_APP_CHAT_WIDGET;

      if (domain) return domain.replace(/\/+$/, '');

      return domain;
    },
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    isLighter(input, maxHsp) {
      /* eslint no-bitwise: ["error", { "allow": [">>", "&"] }] */
      // If hex --> Convert it to RGB: http://gist.github.com/983661
      if (input.indexOf('#') === 0) input = input.slice(1);

      if (input.length < 5) input = input.replace(/./g, '$&$&');

      const color = +(`0x${input}`);

      const r = color >> 16;
      const g = (color >> 8) & 255;
      const b = color & 255;

      // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
      return Math.sqrt((0.299 * (r * r)) + (0.587 * (g * g)) + (0.114 * (b * b))) > maxHsp;
    },
    toggleVisibility() {
      this.visible = !this.visible;
    },
    updateMainColor(color) {
      this.configs.mainColor = color.hex;
    },
    updatePushColor(color) {
      this.configs.pushColor = color.hex;
    },
    async copyData() {
      this.$toast.show({
        title: 'Widget',
        content: 'Código copiado',
        type: 'success',
      });

      this.$clipboard(this.$refs.code.textContent);
    },
  },
};
</script>

<style lang="scss" scoped>
.script-content {
  height: auto;
}

textarea.form-control {
  min-height: 200px;
}

.widget-config-colors::v-deep {
  .vc-sketch-presets > div:last-child {
    display: none;
  }
}

.widget-config-aligns {
  border: thin solid #dcdcdc;
  border-radius: 4px;

  p {
    margin: 0;
    min-height: 80px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: thin solid #efefef;
  }

  button {
    background: transparent;
    border: thin solid #dcdcdc;
    outline: none;
    border-radius: 6px;
    width: 100%;
    min-height: 10px;
    transition: all ease .2s;

    &:hover, &.active {
      background: #dcdcdc;
    }
  }
}

.widget-config-colors {
  padding: 1em 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.widget {
  border-radius: .3em;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
  font-size: 10pt;
  background: #efefef;
  position: fixed;
  bottom: 5px;
  // right: 5px;
  z-index: 1151;
  overflow: hidden;
  height: 0;
  width: 0;

  &.left {
    left: 5px;
  }

  &.right {
    right: 5px;
  }

  &.center {
    transform: translateX(-50%);
    left: 50%;
  }

  &, * {
    transition: all .2s;
  }

  input[type="text"], textarea, button {
    border-radius: 0;
    -webkit-appearance: none;
    line-height: 1;
  }

  &.open {
    box-shadow: 0 5px 25px 9px rgba(0,0,0,.25);
    height: 480px;
    width: 320px;
  }

  & > header {
    position: relative;
    z-index: 101;
    text-align: center;
    height: 62px;
    box-shadow: 0 2px 6px -3px rgba(0,0,0,.5);
    color: #fff;

    button {
      background: transparent;
      border: none;
      height: 100%;
      width: 54px;
      float: left;

      &.widget-r {
        float: right;
      }

      i {
        display: inline-block;
        background: center center no-repeat;
        height: 16px;
        width: 16px;
      }
    }

    h1 {
      padding: 0 65px;
      padding: 0;
      margin: 0;
      height: 62px;
      font-size: 9pt;
      font-weight: bold;
      text-align: left;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-weight: 500;
      overflow: hidden;
      color: inherit;

      &::before {
        vertical-align: middle;
        display: inline-block;
        content: "";
        height: 100%;
        width: 0;
      }
    }
  }

  button {
    cursor: pointer;
    outline: none;
  }

  & > section, & > footer {
    border: 0 solid #ccc;
  }

  & > section {
    border-width: 0 thin 0 thin;
    height: calc(100% - 62px - 44px);
    overflow: auto;
    overflow-x: hidden;
  }

  & > footer {
    background: #fff;
    border-radius: 0 0 .3em .3em;
    border-width: thin;
    position: relative;
    height: 44px;

    input[type=text] {
      border: none;
      background: #fff;
      width: calc(100% - 46px);
      padding: 12px 2px 12px 74px;
      height: 100%;
      resize: none;
      position: relative;
      z-index: 100;
      overflow: auto;
      overflow-x: hidden;
      overflow-wrap: normal;
      white-space: pre;
      line-height: normal;
    }

    & > .widget-btn {
      position: absolute;
      right: 6px;
      top: 6px;
    }
  }

  button > i,
  .emojis::v-deep .popup-box-container button i {
    background: center center no-repeat;
    display: block;
    height: 64%;
    width: 64%;
    margin: 0 auto;
  }
}

.widget-msg {
  clear: both;
  position: relative;
  padding: 14px 28px;
  max-width: 70%;
  max-width: 90%;
  min-width: 75%;
  float: left;

  & > div {
    position: relative;
    padding: 12px;
    padding-bottom: 20px;
    background: #fff;
    border-radius: 0 5px 5px 5px;

    & > span {
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
  }

  .widget-status {
    padding: 2px 10px;
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;

    time {
      margin-top: 10px;
      text-align: right;
      font-size: 75%;
    }
  }

  &.me {
    float: right;

    & > div {
      background: currentColor;
      border-radius: 5px 0 5px 5px;

      & > span {
        color: #fff !important;
      }
    }

    .widget-status {
      color: #fff;
    }
  }

  & > footer {
    color: #070707;
    padding: 6px 2px;
    font-size: 78%;

    span {
      float: right;
    }
  }

  &::before {
    display: block;
    content: " ";
    height: 0;
    position: absolute;
    pointer-events: none;
    border: solid transparent;
    border-top-color: #fff;
    border-right-color: #fff;
    border-width: 7px;
    left: 16px;
    top: 14px;
  }

  &.me::before {
    border-color: transparent;
    border-top-color: currentColor;
    border-left-color: currentColor;
    left: auto;
    right: 17px;
  }
}

.widget-msg-status {
  margin-left: 4px;
  letter-spacing: -5px;
  font-weight: bolder;
}

.widget-btn, .emojis::v-deep .popup-box-container button {
  font-size: 20pt;
  padding: 0;
  background: transparent;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: .2em;
  cursor: pointer;
  vertical-align: middle;
}

.widget-placeholder {
  pointer-events: none;
  color: #cfcfcf;
  position: absolute;
  z-index: 101;
  top: 12px;
  left: 80px;
}

.widget-extras {
  background: #fff;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 101;
  height: 100%;
  border-radius: 5px;
  padding: 5px 0 0 5px;
}

.widget-send svg {
  display: block;
  fill: currentColor;
}

.widget-emoji, .emojis::v-deep .widget-emoji {
  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 1000 1000%22 fill=%22%236c6c6c%22%3E%3Cpath d=%22M379.2 457.5c33.3 0 60.3-27 60.3-60.3s-27-60.4-60.3-60.4-60.3 27-60.3 60.4c0 33.3 27 60.3 60.3 60.3zM500 10C229.4 10 10 229.4 10 500s219.4 490 490 490 490-219.4 490-490S770.6 10 500 10zm0 914.6C265.4 924.6 75.3 734.5 75.3 500S265.4 75.3 500 75.3c234.5 0 424.6 190.1 424.6 424.6.1 234.6-190.1 424.7-424.6 424.7zm120.4-467.1c33.4 0 60.3-27 60.3-60.3s-26.9-60.4-60.3-60.4c-33.3 0-60.3 27-60.3 60.4 0 33.3 27.1 60.3 60.3 60.3zm100.5 90c-16.2 0-30.3 9.6-36.5 23.6-47.3 47.4-112.4 77-184.6 77s-137.3-29.6-184.6-77c-6.3-14-20.2-23.6-36.5-23.6-22.2 0-40.2 18-40.2 40.3 0 13 6.2 24.4 15.8 31.8l-2.1 2.1c62.2 65.8 150 107 247.6 107 102.7 0 194.6-45.7 257.2-117.5l-2.1-2c3.9-6.2 6.2-13.4 6.2-21.2.1-22.4-17.9-40.5-40.2-40.5z%22/%3E%3C/svg%3E') !important;
}
.widget-attach {
  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns%3D%22http://www.w3.org/2000/svg%22 viewBox%3D%220 0 1000 1000%22 fill%3D%22%236c6c6c%22%3E%3Cpath d%3D%22M841.5 390.5c-15.4-11.1-36.8-7.6-47.9 7.7L463.5 856.1c-.1-.1-.3-.2-.5-.3-.9 1.4-1.7 2.9-2.7 4.2-47.6 66.1-140.1 81.1-206.1 33.3S173.3 752.9 221 686.8c0-.1.1-.1.1-.2-.1-.1-.2-.1-.3-.2l409.1-567.3c31.6-43.8 92.9-53.7 136.6-22.1 43.7 31.7 53.6 93.1 22 136.9-.8 1-258 357-295.6 408.8l.1.1c-1.8 2.7-4.2 5.7-5.6 7.7-14.4 20-42.4 24.5-62.4 10.1s-24.5-42.5-10.1-62.5c.8-1.1 2.9-4.7 4.5-7.1l216.2-299.9c11.1-15.4 7.6-36.8-7.8-48-15.3-11.1-36.8-7.6-47.9 7.7l-219 304.4c-1 1.4-1.7 2.9-2.5 4.4h.1c-35.4 50.7-23.9 120.5 26.4 156.9 50.7 36.7 121.5 25.2 158.1-25.6 1.4-2 2.6-4.1 3.8-6.2.1.2.2.3.2.4l301.6-417.9c47.8-73.9 30-173.5-42.1-225.6-73.8-53.4-176.9-37.2-231 35.9 0 0-.1 0-.1-.1L163.3 649.1c0 .1-3.7 5.2-3.8 5.2.2.1.7-.1 1-.1-63.7 96.4-40.8 226.6 53.5 294.9 92.7 67 220.3 49.7 292.4-37 .1.4.1 1.1.3 1.4.1-.1 7.4-10.3 7.5-10.4l334.9-464.5c11.2-15.5 7.7-36.9-7.6-48.1z%22/%3E%3C/svg%3E') !important;
}
.widget-attach-upload {
  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg version=%221.1%22 xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 40 40%22%3E%3Cg fill=%22%23000%22%3E%3Cpath opacity=%220.2%22 d=%22M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z%22/%3E%3Cpath d=%22M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z%22%3E%3CanimateTransform attributeType=%22xml%22 attributeName=%22transform%22 type=%22rotate%22 from=%220 20 20%22 to=%22360 20 20%22 dur=%220.5s%22 repeatCount=%22indefinite%22/%3E%3C/path%3E%3C/g%3E%3C/svg%3E') !important;
}
.widget-min {
  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 1000 1000%22%3E%3Cpath d=%22M 10,510 500,1000 990,510 892,412 500,804 108,412 Z%22 fill=%22%23fff%22/%3E%3C/svg%3E') !important;
}
.widget-close {
  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 1000 1000%22%3E%3Cpath d=%22M990,108.7L598.7,500L990,891.3L891.3,990L500,598.7L108.7,990L10,891.3L401.3,500L10,108.7L108.7,10L500,401.3L891.3,10L990,108.7z%22 fill=%22%23fff%22/%3E%3C/svg%3E') !important;
}

.widget-launch {
  outline: none;
  cursor: pointer;
  border: none;
  border-radius: 4rem;
  background: #0E1421;
  height: 4rem;
  width: 4rem;
  box-shadow: 0 3px 6px rgba(0,0,0,.11), 0 2px 3px rgba(0,0,0,.18);
  pointer-events: auto;
  position: fixed;
  bottom: 11px;
  z-index: 1150;
  -webkit-appearance: none;
  transition: all ease .2s;

  &.left {
    left: 5px;
  }

  &.right {
    right: 5px;
  }

  &.center {
    transform: translateX(-50%);
    left: 50%;
  }

  i {
    display: block;
    height: 64%;
    width: 64%;
    margin: 0 auto;
    background: center center no-repeat;
    background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 height=%2238%22 width=%2232%22 viewBox=%220 0 130 150%22 fill=%22%23fff%22%3E%3Cpath d=%22m 48.108411,131.10047 c -2,0.45 -9.67,-6.3 -16.19,-11 -8.55,-6.3 -18,-12.6 -18.22,-17.54 V 43.830463 a 9.35,9.35 0 0 0 -2.92,0.27 c 0,0 -9.4500003,0.63 -9.4500003,14.57 0.22,11.7 0.22,55.330007 0.22,55.330007 0,0 -0.22,13.49 7.2,15.1 10.1200003,2 9.6700003,0.9 9.6700003,7.2 0,5.85 -0.45,12.6 -0.45,12.6 0,0 2,-0.68 10.57,-5.63 10.12,-6.07 12.82,-7.19 20.24,-5.84 7.87,1.57 59.369,11.24 59.369,11.24 0,0 10.57,1.8 10.35,-6.52 0,-3.6 0.22,11 0,-25.86 0,0 -19.339,3.59 -37.999,7.87 -16.41,3.6 -30.36,6.29 -32.38,7%22/%3E%3Cpath d=%22m 40.008099,44.731322 a 5.48,5.48 0 0 0 -5.400391,5.398438 v 24.509765 a 5.48,5.48 0 0 0 5.400391,5.400391 l 47.451171,-6.75 a 5.47,5.47 0 0 0 5.398438,-5.400391 v -11 A 5.47,5.47 0 0 0 87.45927,51.500854 v -0.01953 z m 9.160156,10.984375 a 7,7 0 0 1 7.291015,6.994141 7,7 0 0 1 -7,7 7,7 0 0 1 -0.291015,-13.994141 z m 29.935547,1.589844 a 5.4,5.4 0 0 1 5.625,5.394531 5.48,5.48 0 0 1 -5.400391,5.400391 5.4,5.4 0 0 1 -0.224609,-10.794922 z%22 /%3E%3Cpath d=%22m 128.61841,105.45047 c 0,-0.22 -1.57,-34.18 -2,-43.63 -0.23,-6.3 -2.7,-9 -2.7,-9 0,0 -9.9,-8.1 -13.95,-11.25 -3.14,-2.47 -8.09,-3.82 -9.22,-4 h -0.42 c -1.569,-0.22 -12.139,-2 -25.179,-4 l 9,-5.17 -8.55,-6.74 a 10.59,10.59 0 0 0 5.85,-9.68 10.79,10.79 0 0 0 -10.85,-10.88 10.66,10.66 0 0 0 -10.8,10.79 10.48,10.48 0 0 0 7.2,10.13 l 7,5.62 -7.67,4.46 c -18.66,-2.93 -38.9,-6.3 -42.73,-7 -6.52,-1.12 -5.84,5.18 -5.84,5.18 v 66.82 c 0,4.720007 -0.68,6.750007 5.62,11.240007 7.2,5.4 22.94,17.55 22.94,17.55 0.67,0.45 1.57,1.12 2.25,0.9 15.52,-3.6 60.939,-13.27 73.089,-15.75 7.64,-1.57 7,-4 7,-5.62 M 70.818411,6.720463 a 5.18,5.18 0 0 1 0,10.35 5.23,5.23 0 0 1 -5.17,-5.18 5.38,5.38 0 0 1 5.17,-5.17 m 29.909,83 c -11.469,1.57 -14.619,0.22 -14.619,5.85 v 0.89 c 0.23,9.900007 -0.44,7.880007 -6.29,3.600007 a 0.22,0.22 0 0 1 -0.23,-0.220003 c -6.07,-4.000004 -8.32,-5.400004 -12.82,-4.270004 -4.5,1.13 -37.55,7.640007 -37.55,7.640007 0,0 -6.53,1.13 -6.53,-3.820007 0.23,-5 0,-63.2 0,-63.42 0,-1.58 0.23,-5.85 6.08,-4.95 7.42,1.08 70.16,11.91 70.16,11.91 0,0 6.299,0.67 6.079,7 -0.45,6.3 0,28.56 0,32.61 0.22,1.13 0,6.52 -4.28,7.2%22/%3E%3C/svg%3E');
  }
}

.widget-push {
  font-family: Consolas, Verdana, sans-serif;
  font-size: 7pt;
  font-weight: bold;
  position: absolute;
  z-index: 101;
  left: 0;
  top: 0;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  color: #fff;
  background-color: #00cc00;
  background-image: linear-gradient(0, rgba(0,0,0,.3) 0%, rgba(0,0,0,0) 100%);
  padding: 0 .7em;
  border-radius: 1em;
  box-shadow: 0 0 2px rgba(0,0,0,.8);
  text-shadow: 1px 1px 1px rgba(0,0,0,.32);
  animation: bounceAnimation .35s ease-out infinite alternate;
  animation-play-state: running;
}

@keyframes bounceAnimation {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-4px);
  }
}

.widget {
  header.lighter,
  .widget-msg.me.lighter > div > span,
  .widget-msg.me.lighter > div time,
  .widget-msg.me.lighter .widget-status,
  .widget-msg.me.lighter .widget-msg-status {
    color: #000 !important;
  }

  .widget-min.lighter {
    background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 1000 1000%22%3E%3Cpath d=%22M 10,510 500,1000 990,510 892,412 500,804 108,412 Z%22 fill=%22%23000%22/%3E%3C/svg%3E') !important;
  }

  .widget-close.lighter {
    background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 1000 1000%22%3E%3Cpath d=%22M990,108.7L598.7,500L990,891.3L891.3,990L500,598.7L108.7,990L10,891.3L401.3,500L10,108.7L108.7,10L500,401.3L891.3,10L990,108.7z%22 fill=%22%23000%22/%3E%3C/svg%3E') !important;
  }

  // .lighter .widget-logo {
  //   background-image: url('../assets/logo.svg#dark') !important;
  // }
}
</style>
